const getEvent = (actionType) =>
  actionType === 'reserve' ? ['Schedule', 'agendapro-reserve'] : ['InitiateCheckout', 'agendapro-begincheckout'];

/**
 * Origen que viaja en cada evento del pixel del comercio, para que pueda separar en Meta lo que le
 * llega por su micrositio de lo que le llega por el Marketplace de AgendaPro.
 *
 * El comercio ya podía separarlos con reglas de URL sobre el dominio
 * (`{comercio}.site.agendapro.com` vs `agendapro.com`), pero es frágil: la regla del Marketplace
 * tiene que ser "es igual a" y no "contiene", porque el dominio del micrositio también contiene
 * `agendapro.com`. Con este campo filtra por un valor exacto y no depende de las URLs.
 *
 * ⚠️ El nombre del campo tiene que ser IDÉNTICO al del Marketplace
 * (`agendapro-marketplace-frontend`, que emite el mismo campo con el valor `marketplace`). Si sólo
 * lo manda una de las dos superficies el comercio no puede filtrar por él, porque "la otra" queda
 * definida como ausencia del campo, y por ausencia no se puede filtrar.
 *
 * ⚠️ Una vez que los comercios armen filtros encima, cambiar el nombre o el valor les rompe la
 * medición en silencio.
 *
 * Nota: acá los eventos van con `track` sin acotar, así que el campo también viaja a los pixeles
 * de AgendaPro que estén inicializados en la página. Es inocuo, pero es un síntoma de lo mismo
 * que ya se corrigió en el Marketplace usando `trackSingle`.
 */
const SOURCE_PARAMS = { ap_source: 'sitio' };

export const FbPixel = {
  pageview() {
    window.fbq('track', 'PageView', SOURCE_PARAMS);
  },
  event(name, options = {}) {
    const events = getEvent(name);

    events.forEach((event) => {
      window.fbq('track', event, { ...SOURCE_PARAMS, ...options });
    });
  },
};
